export default __webpack_public_path__ + "static/media/anon1.d4d2b180.png";